import { Expose } from "class-transformer";
import { IsInt, IsOptional } from "class-validator";

import { CDColumn } from "../orm";

export class DynamicPricingInputs {
    /**
     * The value of this property is copied over from the offer for purposes of dynamic pricing to be consistent.
     * To get precise up to date values use the travelEstimates property on order.
     * Set only for orders created from managed and flexible offers.
     */
    @CDColumn()
    @IsInt()
    @Expose()
    @IsOptional()
    public distanceKm?: number;

    /**
     * The value of this property is copied over from the offer for purposes of dynamic pricing to be consistent.
     * To get precise up to date values use the travelEstimates property on order.
     * Set only for orders created from managed and flexible offers.
     */
    @CDColumn()
    @IsInt()
    @Expose()
    @IsOptional()
    public travelTimeMinutes?: number;
}
